import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { EOSSchemaObject } from '../EOSSchema';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import { EOSListing } from '../Pages';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'EOS';

export function EOSAddEdit(props) {

    const [title, setTitle] = useState("Add Package Creation");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [collectionpoint, setCollectionpoint] = useState();
    const [users, setUsers] = useState();
    const [eosData, setEosData] = useState([]);
    const [eos, setEOS] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        aspNetUserId: '0',
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "EOS completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isEOSEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(EOSSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        trackPromise(
            getGroupsForDropdown()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [eos.groupID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointsAndUsersForDropDown()
        )
        handleSearch();
    }, [eos.operationEntityID]);

    useEffect(() => {
        handleSearch();
    }, [eos.collectionPointID]);

    useEffect(() => {
        handleSearch();
    }, [eos.aspNetUserId]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEOSLISTING');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isEOSEnabled = permissions.find(p => p.permissionCode == 'ENABLEEOS');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isEOSEnabled: isEOSEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setEOS({
            ...eos,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        setTitle("EOS");
        getGroupsForDropdown();
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(eos.groupID);
        setOperationEntity(opEntities);
    }

    async function getCollectionPointsAndUsersForDropDown() {

        const collectionPoints = await services.GetAllCollectionPoints(eos.operationEntityID, eos.groupID);
        setCollectionpoint(collectionPoints);

        const users = await services.GetActiveAspNetUser(eos.groupID, eos.operationEntityID);
        setUsers(users);
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, EOSSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        if (e.target.name == "groupID") {
            setEOS({
                groupID: value,
                operationEntityID: '0',
                collectionPointID: '0',
                aspNetUserId: '0',

            })
        } else if (e.target.name == "operationEntityID") {
            setEOS({
                groupID: eos.groupID,
                operationEntityID: value,
                aspNetUserId: '0',
                collectionPointID: '0'
            })
        }
        else if (e.target.name == "collectionPointID") {
            setEOS({
                groupID: eos.groupID,
                operationEntityID: eos.operationEntityID,
                collectionPointID: value,
                aspNetUserId: '0'
            })
        }
        else {
            setEOS({
                groupID: eos.groupID,
                operationEntityID: eos.operationEntityID,
                collectionPointID: eos.collectionPointID,
                aspNetUserId: value
            });
        }
        setErrors(error);
    }

    async function handleSearch(e) {

        if (e !== undefined) {
            const errorMessages = validate(schema, eos);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.getEOSData(eos);
        setEosData(response);
    }

    async function completeEOS(data) {
        var result = await services.completeEOS(data);

        if (result.statusCode === "Success") {
            setMessageModel({ ...messageModel, hidden: false });
            const response = await services.getEOSData(eos);
            setEosData(response);
        } else {
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: "Error occured. Try agin." })
        }
        setTimeout(() => {
            modalDismissHandler();
        }, 1500);
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setEOS({
            ...eos,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointID: '0',
            aspNetUserId: '0',
        });
        setEosData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                />
                            </div>
                            <hr />
                            <form disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            id="groupID"
                                            name="groupID"
                                            value={eos.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={eos.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointID">Collection point</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointID"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={eos.collectionPointID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection point--</MenuItem>
                                            {generateDropDownMenu(collectionpoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText error>{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="aspNetUserId">User</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="aspNetUserId"
                                            id="aspNetUserId"
                                            name="aspNetUserId"
                                            value={eos.aspNetUserId}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select User--</MenuItem>
                                            {generateDropDownMenu(users)}
                                        </Select>
                                        {errors["aspNetUserId"] && <FormHelperText error>{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, eos)}
                                        type="button"
                                        onClick={(e) => handleSearch(e)}
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                                <EOSListing eosData={eosData} handleClick={completeEOS} eosButtonEnabled={permissionList.isEOSEnabled} />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
            />
        </Fragment>
    );
}